module.exports = __webpack_public_path__ + "dd1bff58d5921e9d35ddb8a6036cee9c.svg";